// The shared attribution field list, read from the contract so browser capture
// and server events cannot drift from it.
import contract from '../contract/segment-events.json' with { type: 'json' };

export const ATTRIBUTION_FIELDS = Object.keys(contract.definitions.attribution_fields);
